import { html, nothing, TemplateResult } from 'lit';
import type { TefComs4csMicroFrontend } from '@src/components/tef-coms4cs.js';
import type { ConsentStore } from '@src/state/ConsentStore.js';
import { stripHtml } from '@src/util/helpers.js';

export function consentTemplateOverview(this: TefComs4csMicroFrontend, consent: ConsentStore): TemplateResult {
  const { featureTitlesAsString } = consent;
  return html`
      <div class="row">
        <div class="col">${stripHtml(consent.shortScope!)}</div>
          ${featureTitlesAsString
  /* eslint-disable @typescript-eslint/indent */
            ? html`
              <div class="col">
                <strong>${featureTitlesAsString}</strong>
              </div>`
            : nothing
          }
      </div>
  `;
}
